<template>
   <div class="row">
      <div class="col-sm-12 col-md-8 col-lg-7 col-centered create-report-card">
         <div class="card">
            <div class="container p-10">
               <div class="custom-title text-center pb-10">
                  Sign Document
               </div>
               <div class="ss-subheader mt-10">Personal Information</div>
               <div class="row pt-9">
                  <div class="col-6">
                     <label class=" font-weight-bold">Name</label>
                     <div class="sign-info-container">
                        <input @input="onInput" class="url-input-wrapper"
                               placeholder="Enter your name here" style="padding-left: 15px;" v-model="swap.name"/>
                        <div class="error" v-if="!$v.swap.name.required">Field is required</div>
                     </div>
                  </div>
               </div>
               <hr style="margin-top: 3rem;margin-bottom: 3rem;border: 0;border-top: 1px solid rgb(212 218 224);"/>
               <div class="ss-subheader mt-6">Signature</div>
               <div class="signature-sign-wrapper mt-10">
                  <div class="position-relative">
                     <i class="mdi mdi-menu-down typeface-select-icon"></i>
                     <select class="signature-sign-select" id="typeface" v-model="swap.font">
                        <template v-for="font in utils.fonts">
                           <option :value="font">{{ font }}</option>
                        </template>
                     </select>
                  </div>
                  <div class="sign-doc-container">
                     <input :style="`font-family: ${swap.font}`" @input="onInput"
                            class="signature-input-wrapper" placeholder="Enter your signature here"
                            v-model="swap.signature"/>
                     <div class="error" v-if="!$v.swap.signature.required">Field is required</div>
                  </div>
               </div>
               <p class="text-muted">
                  By signing this documents with an electronic signature, I agree that such
                  signature will be as valid as handwritten signatures to the extent allowed by local law.
               </p>

               <!-- network error -->
               <p class="error" v-if="utils.is_error_active">
                  Server encountered error, please try again
               </p>

               <div class="text-right mt-10">
                  <button :class="{'disabled': !utils.is_inputs_valid}"
                          @click="createSignproof"
                          class="btn btn-success font-weight-bold custom-btn-create-report px-6 py-3" ref="accept_btn">
                     Accept And Sign
                  </button>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>

   import generalMixin from '../../core/mixins/generalMixin';
   import {validationMixin} from 'vuelidate';
   import {required} from 'vuelidate/lib/validators';
   import {
      UPLOAD_TEMP_PDF,
      CHANGE_COMPONENT,
      SAVE_REPORT_FIELDS,
      SAVE_REPORT_TO_DATABASE,
      SAVE_REPORT_TO_BLOCKCHAIN
   } from '../../core/store/modules/report';
   import {
      SIGNPROOF_SIGNSTAMP_PDF
   } from '../../core/store/modules/report.signproof';

   export default {
      name: "Report.Signproof.Sign",
      data() {
         return {
            utils: {
               fonts: [
                  'Dancing Script',
                  'Satisfy',
                  'Gochi Hand'
               ],
               is_inputs_valid: false,
               is_error_active: false,
            },
            swap: {
               name: '',
               font: 'Dancing Script',
               signature: ''
            }
         }
      },
      validations: {
         swap: {
            name: {
               required,
            },
            signature: {
               required
            }
         },
      },
      mixins: [generalMixin, validationMixin],
      methods: {
         onInput() {
            this.$v.swap.$touch();
            this.utils.is_inputs_valid = !this.$v.swap.$error;
         },
         createSignproof() {

            this.utils.is_error_active = false;

            const btn = this.$refs["accept_btn"];

            this.addSpinnerLight(btn);

            const fields = {
               type: 'SIGNPROOF',
               fullpage: '---',
               activate_js: '---',
               sign_font: this.swap.font,
               sign_name: this.swap.name,
               sign_sign: this.swap.signature,
               blockchain: localStorage.getItem('sel_bc'),
               all_signatures: 'INCOMPLETE',
            };

            this.$store.dispatch(SAVE_REPORT_FIELDS, fields);

            Promise.all([
               this.$store.dispatch(UPLOAD_TEMP_PDF, 'signproof')
                   .then(() => this.$store.dispatch(SIGNPROOF_SIGNSTAMP_PDF))
                   .then(() => this.$store.dispatch(SAVE_REPORT_TO_BLOCKCHAIN))
                   .then(() => this.$store.dispatch(SAVE_REPORT_TO_DATABASE))
            ]).then((res) => {
               console.log(res);
               this.$store.dispatch(CHANGE_COMPONENT, 'appReportSignproofInvite');
            }).catch((e) => {
               console.log(e);
               this.removeSpinner(btn);
               this.utils.is_error_active = true;
            }).catch((e) => {
               console.log(e);
               this.removeSpinner(btn);
               this.utils.is_error_active = true;
            });

         }
      }
   }
</script>

<style scoped>
   .header {
      display: none !important;
   }

   #kt_subheader {
      visibility: hidden;
   }

   .btn-pre-signDoc {
      color: #82037e;
      background-color: #82037e17;
      border-color: #82037e;
      height: 31px;
      font-weight: 500 !important;
      font-size: 10px !important;
      line-height: 0px !important;
   }

   .typeface-select-icon {
      position: absolute;
      left: 111px;
      top: -3px;
      font-size: 24px;
      color: #acb4bb;
   }

   .signature-sign-select {
      height: 30px;
      cursor: pointer;
      font-size: 14px;
      outline: 0;
      font-family: Exo2-SemiBold;
      color: #acb4bb;
   }

   .ss-subheader {
      border-left: 4px solid #44566c;
      font-size: 15px;
      line-height: 14px;
      padding-left: 7px;
      color: #44566c;
      font-weight: 800;
      letter-spacing: -0.08px;
   }

   .sign-info-container {
      position: relative;
      background: #ffffff;
      border: 1px solid #c5cdd4;
      height: 45px;
      border-radius: 8px;
   }

   .sign-doc-container {
      border-bottom: 1px solid #c7c7ce;
      height: 45px;
      width: 500px;
      margin: 0 auto;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 240px;
   }

   input.signature-input-wrapper {
      font-size: 23px;
      height: 46px;
      width: 100%;
      padding-left: 0;
      border: none;
      outline: 0;
      font-weight: 400;
      text-align: center;
      font-family: 'Dancing Script', cursive;
      /* font-family: 'Satisfy', cursive;
      font-family: 'Gochi Hand', cursive; */
   }

   .signature-sign-wrapper {
      padding: 15px;
      width: auto;
      margin: 0 auto;
      background: #f3f6f9;
      border: 2px dashed #d4dae0;
      height: 260px;
      border-radius: 2px;
      margin-bottom: 20px;
   }
</style>